import {
  getAsiaScaleAPI,
  getBarthelIndexAPI,
  getCoordinationAPI,
  getFingerGripAPI,
  getGcScaleAPI,
  getMaScaleAPI,
  getMmtScaleAPI,
  getMocaScaleAPI,
  getNihsScaleAPI,
  getPeakFlowMeterAPI,
  getRasScaleAPI,
  getReflexesAPI,
  getRomScaleAPI,
  getRpeScaleAPI,
  getSixMinuteWalkAPI,
  getTcmScaleAPI,
  getVaScaleApi,
  getVcgScaleAPI,
} from "../../../../services/physio.services";

/**
 * The latest-physio-review response holds only a record id per scale
 * (`{ gcs: 3283, moca: 1428 }`), so submitting it verbatim sent nothing but
 * those ids. Each scale's full record lives behind its own endpoint - the same
 * ones PhysioScalesReviewSummary calls to render the summary.
 */
const SCALE_FETCHERS = {
  asia: getAsiaScaleAPI,
  barthel_index: getBarthelIndexAPI,
  coordination: getCoordinationAPI,
  finger_grip: getFingerGripAPI,
  gcs: getGcScaleAPI,
  mas: getMaScaleAPI,
  mmts: getMmtScaleAPI,
  moca: getMocaScaleAPI,
  nihss: getNihsScaleAPI,
  pefr: getPeakFlowMeterAPI,
  rass: getRasScaleAPI,
  reflexes: getReflexesAPI,
  rom: getRomScaleAPI,
  rpe: getRpeScaleAPI,
  smwt: getSixMinuteWalkAPI,
  tcm: getTcmScaleAPI,
  vas: getVaScaleApi,
  vcgs: getVcgScaleAPI,
};


export const fetchFullScales = async (admissionId, scales) => {
  if (!admissionId || !scales || typeof scales !== "object") return scales ?? null;

  const entries = Object.entries(scales).filter(([, id]) => id);
  if (!entries.length) return scales;

  const resolved = await Promise.all(
    entries.map(async ([key, id]) => {
      const fetcher = SCALE_FETCHERS[key];
      if (!fetcher) return [key, id];
      try {
        const res = await fetcher(admissionId, id);
        const data = res?.data;
        return [key, data && typeof data === "object" ? { id, ...data } : id];
      } catch {
        return [key, id];
      }
    })
  );

  return resolved.reduce((acc, [key, value]) => {
    acc[key] = value;
    return acc;
  }, {});
};

export default fetchFullScales;
